"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messageTemplateApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var messageTemplateApi = exports.messageTemplateApi = {
  findAll: function findAll(params) {
    return (0, _request.default)({
      url: '/messageTemplate',
      params: params
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/messageTemplate/".concat(id),
      method: 'patch',
      data: data
    });
  }
};